import React from "react";

import styles from "./Title.module.css";

const Title = ({ name }) => {
  return (
    <div className={styles.section_title_container}>
      <div className={styles.section_title}>
        <b></b>
        <span className={styles.section_title_main}>{name}</span>
        <b></b>
      </div>
    </div>
  );
};

export default Title;
